import { useSocket } from 'socket.io-react-hook';

export const useGetAddressChangerSocket = () => {
  const socket = useSocket(
    import.meta.env.VITE_ADDRESS_CHANGER_SOCKET_URL, { multiplex: false, withCredentials: true, reconnection: true, autoConnect: true }
  );

  return socket;
};
